// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"EditCsvData_btnWrapper__icSw4","container":"EditCsvData_container__RMlx-","fileWrapper":"EditCsvData_fileWrapper__2XNDT"};